import type { i18n as I18n } from 'i18next';
import { formatApiError } from '@/services/api';

/**
 * Plain-language reason a release call failed, for "Saved as draft. Could not release: <reason>".
 * A known `release.*` code is translated through the errors namespace; anything else falls back to the
 * server's message (already localized by the backend), never an invented one.
 */
export const getReleaseFailureReason = (error: unknown, i18n: I18n): string => {
  const { code, message } = formatApiError(error);
  if (typeof code === 'string' && code.startsWith('release.')) {
    const key = `errors:${code}`;
    if (i18n.exists(key, { keySeparator: false })) {
      return i18n.t(key, { keySeparator: false });
    }
  }
  return message;
};
